import type { Filter } from '../types';

/**
 * Is non "showIssuesWithoutDeployments filter applied
 */
export const isFilterApplied = ({
	assignees,
	environments,
	epicIds,
	fixVersions,
	issueTypeIds,
	text,
}: Filter): boolean => {
	const areAllArraysEmpty = [
		assignees,
		epicIds,
		fixVersions,
		issueTypeIds,
		environments.names,
		environments.types,
	].every((arr) => Array.isArray(arr) && arr.length === 0);

	return !areAllArraysEmpty || text !== '';
};
